import React from 'react'

const Card = (props) => {

  return (
  <div className='card-wrapper my-4 mx-8 lg:mx-24 md:mx-16 md:w-50'>
    <div className="card">
        <img src={props.img} className="card-img h-32 md:h-40" />
        <div className="card-body">
          <h2 className="card-title">{props.title}</h2>
          <h2 className="card-date">{props.date}</h2>
          <p className="card-description md:text-sm">{props.description_1}</p>
          <p className="card-description md:text-sm">{props.description_2}</p>
          <p className="card-description md:text-sm">{props.description_3}</p>
          <p className="card-description md:text-sm">{props.description_4}</p>
        </div>
    </div>
  </div>
  )
}

export default Card